import { __read } from "tslib";
export var Breakpoint;
(function (Breakpoint) {
    Breakpoint[Breakpoint["mobile"] = 0] = "mobile";
    Breakpoint[Breakpoint["mobileLandscape"] = 480] = "mobileLandscape";
    Breakpoint[Breakpoint["tablet"] = 740] = "tablet";
    Breakpoint[Breakpoint["lap"] = 960] = "lap";
    Breakpoint[Breakpoint["desktop"] = 1080] = "desktop";
    Breakpoint[Breakpoint["wide"] = 1300] = "wide";
})(Breakpoint || (Breakpoint = {}));
export var BreakpointNames = Object.freeze(Object.entries(Breakpoint)
    .filter(function (_a) {
    var _b = __read(_a, 1), breakpointName = _b[0];
    return isNaN(Number(breakpointName));
})
    .sort(function (_a, _b) {
    var _c = __read(_a, 2), breakpointValue1 = _c[1];
    var _d = __read(_b, 2), breakpointValue2 = _d[1];
    return Number(breakpointValue1) - Number(breakpointValue2);
})
    .map(function (_a) {
    var _b = __read(_a, 1), breakpointName = _b[0];
    return breakpointName;
}));
export var NextBreakpointDecreaseStep = 0.01;
//# sourceMappingURL=Breakpoint.js.map